import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { retryWhen } from 'rxjs/operators';
import { LoginService } from '../../login-service';

@Component({
    selector: 'overview-name',
    templateUrl: 'overview.component.html',
    providers:[LoginService]
})

export class OverviewComponent implements OnInit {
    //NgModels
    CollaboName:string;
    actorNameJob:string;
    InvoiceNo:string;
    IsView:boolean=false;
    InvoiceDate:string;
    CompanyName:string;
    Address:string;
    City:string;
    Area:string;
    ZipCode:string;
    PhoneNo:string;
    viewInvoiceList:any;
    EmailAddress:string;

    collaboID:string;
    actorID:string;
IsGenerate:boolean=false;
actorsList:any;
GenerateCollaboDetails:any;
    tempPraposaBids:any;
    collaboList=[];
    userType:string;
    userID: any;
    BidsList: any=[];
    invoiceList:any;
    tempInvoiceList:any;
    tempcollaboList: any;
    tempcol=[];
    tempBids=[];
    tempColaboActorDetails: any;
    ColaboActorDetails: any;
    Actorid: string;
    ActorpercentageId: string;
    statusCollabos: any[];
    showproposal:boolean=false;
    showbids:boolean;
    tabtype: string;
    RowCollaboDetils: any;
    showPraposalDetails: any;


    IsDetails:boolean=false;
    detailsColaboList:any;
    tempCol: any;
    State: any;
    Country: any;
    allDetails: any;
    actors: any;
    totalamount: number;
    c: any;
    expandedIndex = 0;
    collabo_paytype: any;
    searchText: any;
    presentCollabos: any[];
    Accordian: any;
    filteredcollabolist: any=[];
    filteredinvoiceList: any;
    collabodetails: any;
    collaboratoramount: number;
    private isCOllapsed:boolean=true;
    constructor(private loginService:LoginService) { 
        this.userType=localStorage.getItem("userType");
        this.userID=localStorage.getItem('USERID');
    }

    ngOnInit() {
        this.GetPraposalBids();
        this.GetInvoices();
     }
     
    opencollabo(item){
        this.c=item;
      }

     GetInvoices(){
         this.loginService.GetInvoices().subscribe(data=>{
            data = JSON.parse(data['_body']);
            this.tempInvoiceList=JSON.parse(JSON.stringify(data));
           
         })
     } 
     GetPraposalBids(){
        this.tempcol=[];
        
        
                        this.loginService.GetPraposalBids().subscribe(data=>
                          {
                              data = JSON.parse(data['_body']);
                              this.tempPraposaBids=JSON.parse(JSON.stringify(data));
                            
                            this.BidsList=this.tempPraposaBids.filter(x=>x.userid.toString()===this.userID.toString() && x.bidstatus=="Accepted");
                            this.loginService.GetCollabos(this.userType).subscribe(data=>
                                {
                                    data = JSON.parse(data['_body']);
                                    this.tempcollaboList=JSON.parse(JSON.stringify(data));
                                  
                                   this.loginService.GetCollaboActorDetails().subscribe(data1=>{
                
                                    data1=JSON.parse(data1["_body"]);
                                    this.tempColaboActorDetails=JSON.parse(JSON.stringify(data1));
                                this.filteredinvoiceList=this.tempInvoiceList.filter(x=>x.userid==this.userID)
                                for(var j=0;j<this.filteredinvoiceList.length;j++){
                                    var filteredcols=this.tempcollaboList.filter(x=>x.id==this.filteredinvoiceList[j].collaboid )
                                    if(filteredcols.length>0){
                                    this.filteredcollabolist.push(filteredcols)
                                    }
                                }
                                var filterArray = this.filteredcollabolist.reduce((accumalator, current) => {
                                    if(!accumalator.some(item => item[0].id === current[0].id )) {
                                      accumalator.push(current);
                                    }
                                    return accumalator;
                                },[]);
                                this.filteredcollabolist=filterArray;
                                this.c=this.filteredcollabolist[0]         
                                });
                            });
                          });
                      } 

                      Searchtext(){
                        this.tempcol=[];
                        this.tempcol=this.presentCollabos;
                       let tempCompany = this.tempcol.filter(
                         (item) => {
                           return (
                             (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
                           );
                         }
                       );
                       this.tempcol = tempCompany;
                      }

    DetailsCollabo(collabo){
this.IsDetails=true;
this.IsGenerate=false;
this.IsView=false;
this.collabodetails=collabo;
this.detailsColaboList=this.BidsList.filter(x=>x.collaboid==collabo.id)
var camount=0;
this.tempBids=[];
for(var i=0;i<this.detailsColaboList.length;i++){
    var invoices=this.tempInvoiceList.filter(x=>x.proposalbidrowid==this.detailsColaboList[i].rowid)
    if(invoices.length>0){
    this.tempBids.push({
     bidid:this.detailsColaboList[i].rowid,
     totalhours:this.detailsColaboList[i].totalhours,
     name:this.detailsColaboList[i].name,
     amount:parseInt(this.detailsColaboList[i].amount)-parseInt(this.detailsColaboList[i].servicecharge),
     user_name:this.detailsColaboList[i].user_name,
     createddate:this.detailsColaboList[i].createddate,
     actorid:this.detailsColaboList[i].actorid,
     invoiceList:invoices,
     ispaid:invoices[0].ispaid,
    })
    camount=camount+this.tempBids[i].amount
}
}
this.collaboratoramount=camount
this.collabo_paytype=collabo.pay_type;

    }
      calculateDiff(sentDate,enddate) {
        var date1:any = new Date(sentDate);
        var date2:any = new Date(enddate);
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    
        return diffDays;
    }
    ViewInvoice(row,c){
        this.allDetails=c;
        this.actors=row;
        if(this.collabo_paytype=="hour"){
        this.totalamount=parseInt(row.amount)*parseInt(row.totalhours)
        }
        else{
            this.totalamount=row.amount;
        }
        this.IsDetails=false;
        this.IsGenerate=false;
        this.IsView=true;
        this.viewInvoiceList=row.invoiceList[0];

    }
    backtoDetails(){
        this.IsDetails=true;
this.IsGenerate=false;
this.IsView=false;
    }
    backtoCollabos(){
        this.IsDetails=false;
        this.IsGenerate=false;
        this.IsView=false;
    }
    GenerateInvoice(row,actors){
        this.IsGenerate=true;
        this.IsDetails=false;
        this.IsView=false;
        this.GenerateCollaboDetails=row;
       var invoices=[];
        invoices=this.tempInvoiceList.filter(x=>x.collaboid==row.id && x.userid==this.userID);
       var count=invoices.length;
       count=count+1
       this.InvoiceNo="INV" + row.id +this.userID+ "0"+count;
    this.actorsList=actors;
    this.CollaboName=this.GenerateCollaboDetails.title;
    this.actorNameJob=actors.name;
    this.collaboID=this.GenerateCollaboDetails.id;
    this.Actorid=actors.ActorId;
    }
    Cancel(){
        this.IsDetails=true;
        this.IsGenerate=false;
        this.IsView=false;
    }
    SaveInvoice(){
        const json={
            rowid:"",
            collaboid:this.collaboID,
            actorid:this.Actorid,
            userid:this.userID,
            invoiceno:this.InvoiceNo,
            invoicedate:this.InvoiceDate,
            companyname:this.CompanyName,
            address:this.Address,
            city:this.City,
            state:this.State,
            country:this.Country,
            zipcode:this.ZipCode,
            phoneno:this.PhoneNo,
            email:this.EmailAddress,
            createdby:'admin',
            updatedby:'admin'
        }


        this.loginService.SaveInvoices(json).subscribe(data=>{
            this.loginService.GetInvoices().subscribe(data=>{
                data = JSON.parse(data['_body']);
                this.tempInvoiceList=JSON.parse(JSON.stringify(data));
            this.GetPraposalBids();
            this.IsGenerate=false;
            this.IsDetails=true;
        })
        })
    }
    accordianValue(value)
    {
      this.Accordian=value;
    }
}
